import { FC } from "react";
import { Grid } from "antd";
import { withConditionalComponent } from "src/HOC/WithMobileComponent";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";
import ExchangeDetailsHeaderWeb from "./layouts/ExchangeDetailsHeader.web";
import ExchangeDetailsHeaderMob from "./layouts/ExchangeDetailsHeader.mob";

const ExchangeDetailsHeaderComponent = withConditionalComponent(ExchangeDetailsHeaderWeb, ExchangeDetailsHeaderMob);

type Props = {
  programName?: string;
  isFetching?: boolean;
};

const ExchangeDetailsHeader: FC<Props> = ({ programName, isFetching }) => {
  const isLargeScreen = !!Grid.useBreakpoint()[MOBILE_BREAKPOINT_KEY];

  return <ExchangeDetailsHeaderComponent trigger={isLargeScreen} props={{ programName, isFetching }} />;
};

export default ExchangeDetailsHeader;
